// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-row-row-oFC2Z {
  height: 60px;
}

.table-row-row-oFC2Z:hover {
  background-color: var(--background-color);
}

.table-row-row-oFC2Z:last-child .table-row-cell-oYWuf {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/table-row/table-row.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".row {\n  height: 60px;\n}\n\n.row:hover {\n  background-color: var(--background-color);\n}\n\n.row:last-child .cell {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `table-row-row-oFC2Z`,
	"cell": `table-row-cell-oYWuf`
};
export default ___CSS_LOADER_EXPORT___;
